import React, { memo, useCallback, useContext, useState } from 'react';

import { Box, Flex, Stack } from '@chakra-ui/layout';
import { Button, TextAreaInput, TextInput, Unform } from 'components';
import ROPA from 'models/Forms/ROPA';
import { IROPAProps, ROPACtx } from 'pages';
import { checkPermission } from 'utils/authentication';

import { BasicInformations } from 'constants/tooltips';
const Item: React.FC<IROPAProps> = ({ functionCallback, index, submit, completed }) => {
  const ctx = useContext(ROPACtx);

  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async function nextPage() {
    localStorage.setItem('load', String(Math.random()));

    setLoading(true);
    if (submit) {
      const resp = await submit();
      if (resp) {
        functionCallback(index + 1);
      }
    } else {
      functionCallback(index + 1);
    }
    setLoading(false);
  }

  const handleSubmit = useCallback(
    async (data: ROPA) => {
      setLoading(true);
      if (submit) {
        const resp = await submit(data, '2 - Informações Básicas');
        if (resp) {
          functionCallback(index + 1);
        }
      } else {
        functionCallback(index + 1);
      }
      setLoading(false);
    },
    [submit, functionCallback, index],
  );

  return (
    <Flex marginTop="1rem" width="100%" direction="column">
      <Unform
        initialData={ctx.data}
        onSubmit={handleSubmit}
        // validationSchema={BasicInformationValidationSchema}
      >
        {checkPermission({ onlyAdmin: true }) ? (
          <>
            <Box>
              <TextInput
                tip={BasicInformations[0].label}
                label="Quem decide sobre o tratamento de dados pessoais? A empresa? Ou algum terceiro?"
                name="hasAnotherController"
                // {...cProps}
              />
            </Box>
            <Box>
              <TextInput
                tip={BasicInformations[1].label}
                label="Em caso de terceiro, especificar."
                name="hasAnotherOperator"
                // {...cProps}
              />
            </Box>
            <Box>
              <TextAreaInput
                rows={3}
                resize="none"
                tip={BasicInformations[2].label}
                label="Quem são os titulares de dados pessoais (a quem os dados se referem)?"
                name="whichHolders"
                // {...cProps}
              />
            </Box>
            <Box>
              <TextAreaInput
                rows={3}
                resize="none"
                tip={BasicInformations[3].label}
                label="De onde vêm os dados?"
                name="sourceOfData"
                // {...cProps}
              />
            </Box>
            <Box>
              <TextInput
                tip={BasicInformations[4].label}
                label="Os dados são compartilhados com terceiros ou outras áreas?"
                name="hasDataShare"
                // {...cProps}
              />
            </Box>
            <Box>
              <TextInput
                tip={BasicInformations[5].label}
                label="Com quem são compartilhados?"
                name="shareWith"
                // {...cProps}
              />
            </Box>
            <Box>
              <TextInput
                // tip={BasicInformations[6].label}
                label="Mais informações"
                name="contractLinkWithOperator"
                // {...cProps}
              />
            </Box>
            <Box>
              <TextInput
                tip={BasicInformations[7].label}
                label="Os dados são armazenados ou enviados para outros países?"
                name="sentAbroad"
                // {...cProps}
              />
            </Box>
            <Box>
              <TextInput
                tip={BasicInformations[8].label}
                label="Por quanto tempo os dados são armazenados?"
                name="custodyTerm"
                // {...cProps}
              />
            </Box>
            <Box>
              <TextAreaInput
                rows={3}
                resize="none"
                tip={BasicInformations[9].label}
                label="Quais são as medidas de segurança técnicas e administrativas empregadas nesta atividade?"
                name="securityMeasures"
                // {...cProps}
              />
            </Box>
            {!ctx.isDetails && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button
                    type="submit"
                    variant="primary"
                    // onClick={nextPage}
                    isLoading={loading}
                    disabled={loading}
                  >
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
            {ctx.isDetails && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button
                    type="submit"
                    variant="primary"
                    // onClick={nextPage}
                    isLoading={loading}
                    disabled={loading}
                  >
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
          </>
        ) : (
          <>
            <Box>
              <TextInput
                tip={BasicInformations[0].label}
                label="Quem decide sobre o tratamento de dados pessoais? A empresa? Ou algum terceiro?"
                name="hasAnotherController"
                isDisabled={completed}
              />
            </Box>
            <Box>
              <TextInput
                tip={BasicInformations[1].label}
                label="Em caso de terceiro, especificar."
                name="hasAnotherOperator"
                isDisabled={completed}
              />
            </Box>
            <Box>
              <TextAreaInput
                rows={3}
                resize="none"
                tip={BasicInformations[2].label}
                label=""
                name="whichHolders"
                isDisabled={completed}
              />
            </Box>
            <Box>
              <TextAreaInput
                rows={3}
                resize="none"
                tip={BasicInformations[3].label}
                label="De onde vêm os dados?"
                name="sourceOfData"
                isDisabled={completed}
              />
            </Box>
            <Box>
              <TextInput
                tip={BasicInformations[4].label}
                label="Os dados são compartilhados com terceiros ou outras áreas?"
                name="hasDataShare"
                isDisabled={completed}
              />
            </Box>
            <Box>
              <TextInput
                tip={BasicInformations[5].label}
                label="Com quem são compartilhados?"
                name="shareWith"
                isDisabled={completed}
              />
            </Box>
            <Box>
              <TextInput
                // tip={BasicInformations[6].label}
                label="Mais informações"
                name="contractLinkWithOperator"
                isDisabled={completed}
              />
            </Box>
            <Box>
              <TextInput
                tip={BasicInformations[7].label}
                label="Os dados são armazenados ou enviados para outros países?"
                name="sentAbroad"
                isDisabled={completed}
              />
            </Box>
            <Box>
              <TextInput
                tip={BasicInformations[8].label}
                label="Por quanto tempo os dados são armazenados?"
                name="custodyTerm"
                isDisabled={completed}
              />
            </Box>
            <Box>
              <TextAreaInput
                rows={3}
                resize="none"
                tip={BasicInformations[9].label}
                label="Quais são as medidas de segurança técnicas e administrativas empregadas nesta atividade?"
                name="securityMeasures"
                isDisabled={completed}
              />
            </Box>
            {!completed && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button type="submit" variant="primary" isLoading={loading} disabled={loading}>
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
          </>
        )}
      </Unform>
    </Flex>
  );
};

export const BasicInformation = memo(Item);
